import md5 from 'crypto-js/md5'
import { getCurrentUserInfo, checkIfUserIsLoggedIn, performActionRequiringLogin } from '@/common/otherService';

function apiToken(index) {
    const userInfo = getCurrentUserInfo();
    var loginToken = userInfo.token
    var now = new Date()
    var nowyear = now.getFullYear()
    var nowmonth = now.getMonth() + 1;
    var nowday = now.getDate()
    var nowhour = now.getHours()
    var nowmin = now.getMinutes()
    var nowsecond = now.getSeconds()
    var tokendate = nowyear + '-' + nowmonth + '-' + nowday
    var tokentime = nowhour + ':' + nowmin + ':' + nowsecond
    var str = md5(index + "&" + tokendate + "&" + tokentime)
    var apiToken = loginToken + '&' + str + "&" + tokendate + "&" + tokentime
    return apiToken

}

export default apiToken